import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from "../../providers/AuthProvider";
import { AircaftData } from '../../Model/AircraftData';
import { ReactSVG } from 'react-svg';
import classes from "./AircraftInput.module.scss";

interface AircraftInputProps {
        value: string;
        aircraftList: AircaftData[];
        onStartValidation: () => void;
        onCompleteValidation: (isValid: boolean, isAPIError:boolean, aircraft?: AircaftData, apiError?:string) => void;
}

export const AircraftInput = ({ value,aircraftList, onStartValidation, onCompleteValidation }: AircraftInputProps) => {

        //Context
        const _authContext = useContext(AuthContext);
        
        //Constants
        const maxLength = 5;
        const required = true;
        const placeholder = "Acft";        

        //States
        const [isValid, setIsValid] = useState<boolean>(true);        
        const [aircraft, setAircraft] = useState(value);
        const [isFocused, setIsFocused] = useState<boolean>(false);
        const [isValidationInProgress, setIsValidationInProgress] = useState<boolean>(false);
        const [acErrorMessage, setACErrorMessag] = useState("");

        //Handlers
        const validateAircraftFromRedux = async () => {
            setIsFocused(false);                                            
            onStartValidation();            
            if(aircraft === "") {
                setIsValid(false);
                setACErrorMessag("Please fill out this field.");
                onCompleteValidation(false,false, undefined);
            } else { 
                setIsValidationInProgress(true); 
                // Check if the aircraft exists in the Redux list
                const validAircraft = aircraftList.find((item: AircaftData) => item.aircraftReg === "N" + aircraft);

                if (!validAircraft) {
                    setIsValid(false);
                    setACErrorMessag("Please enter a valid Aircraft.");
                    onCompleteValidation(false, false, undefined);
                } else {
                    setIsValid(true);
                    onCompleteValidation(true, false, validAircraft);
                }

                setIsValidationInProgress(false);
                
            }                    
        };

        
        return (
            <div>                
                <div className={`${classes.DCACInput} ${isValid ? classes.DCACInputValid : classes.DCACInputNotValid}`}>
                    {isValid ? null : (
                        <div className={classes.DCACInputErrorIcon}>
                            <ReactSVG src="https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/alert/error.svg" />
                        </div>)}                        
                <input
                    data-testid="dcAircraftInput"
                    aria-label="ac"
                    maxLength={maxLength}
                    value={aircraft}
                    disabled={isValidationInProgress}
                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => setAircraft(e.target.value.toUpperCase()) }
                    onBlur={validateAircraftFromRedux}
                    onFocus={() => setIsFocused(true)}>                        
                    </input>
                    
                <span slot="label">{required ? placeholder : `${placeholder} (optional)`}</span>                        
                </div>                                  
                {   isValid ? null : 
                <div data-testid="dcAircraftInputError" className={classes.DCACInputErrorMessage}>
                  <span>{acErrorMessage}</span></div>   }
            </div>                
        );
};